"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _CostPerLeadRecord = _interopRequireDefault(require("./CostPerLeadRecord"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  desiredCostPerLead: (0, _CostPerLeadRecord.default)(),
  portalCurrency: 'USD'
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchCostPerLeadActionTypes.SUCCESS, function (state, action) {
  return state.set('desiredCostPerLead', (0, _CostPerLeadRecord.default)(action.payload.data ? (0, _extends2.default)({}, action.payload.data) : {}));
}), (0, _defineProperty2.default)(_handleActions, _actions.SyncCostPerLeadActionTypes.SUCCESS, function (state, action) {
  return state.mergeIn(['desiredCostPerLead'], action.payload.props);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchPortalCurrencyInfoActionTypes.SUCCESS, function (state, action) {
  return state.set('portalCurrency', action.payload.data.homeCurrency.currencyCode);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;